//Built-In
import React, { Fragment } from 'react';
//External
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "reactstrap";
import cx from "classnames";
import Select from "react-select";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { faXmark } from "@fortawesome/free-solid-svg-icons/faXmark";

class CommonHeaderContent extends React.Component {
    constructor(props) {
        super(props);
        let searchOptions = [];
        let defaultValue = [];
        if (props.selectOptions !== undefined && props.selectOptions != null && props.selectOptions.length > 0) {
            searchOptions = props.selectOptions;
            defaultValue = props.defaultSelect !== undefined ? props.defaultSelect : searchOptions[0];
        }
        this.state = {
            searchOptions: searchOptions,
            selectedSearchOption: defaultValue,
        };
    }
    handleSearch = async (name, value) => {
        let option = { value: name, label: value };
        await this.props.searchChangeNameHandler(option);
    }

    handleChange = async (option) => {
        await this.props.searchChangeHandler(option);
        this.setState({
            selectedSearchOption: option
        });
    }

    handleButtonClick = async () => {
        this.buttonClick.current.click();
    }

    cancelBtnClick = (cancelURL) => {
        if (cancelURL !== undefined && cancelURL !== '') {
            window.location.href = `/#/${cancelURL}`;
        }
    }

    render() {
        let { headerTitle, buttonTxt, cancelBtn, cancelURL, buttonIcon, prefix, buttonOutline, isStatusFilter, isSearchBox, isCampaign, headerMsg, addonButtons, isModal, closeModal, isClassNeeded, badge } = this.props;
        let buttonOutLine = "success";
        let searchOptions = this.state.searchOptions;
        let selectedSearchOption = this.state.selectedSearchOption;
        if (buttonOutline !== undefined) {
            buttonOutLine = buttonOutline;
        }

        return (
            <Fragment>
                <div className={cx('flex flex-col flex-auto min-h-0 relative z-10')}>
                    <div className={`campaign-list-container ${isCampaign !== undefined && !isCampaign ? 'form-view-container' : ''}`}>
                        <div className={`campaign-header ${isCampaign !== undefined && !isCampaign ? 'form-header' : ''}`}>
                            <div className={'flex flex-1 items-center header-left-controls justify-between p-1 w-100'}>
                                <div className={`flex shrink items-center sm:w-512 header-left-shrink ${addonButtons !== undefined && addonButtons.length > 0 && buttonTxt !== "" && isModal ? 'w-50' : ''}`}>
                                    <div className={'flex items-center'}>
                                        <span className={'campaign-header-text hidden sm:flex text-16 md:text-24 mx-12 font-semibold camautoheadertxt'}>{headerTitle}
                                            {
                                                badge && <span className='ml-1 badge rounded-pill bg-info'>{badge.label}</span>
                                            }
                                        </span>
                                    </div>
                                </div>
                                <div className={`d-flex-alone header-controls ${((searchOptions !== undefined && isStatusFilter) || isSearchBox) ? 'col-md-7' : 'col-md-6'}`}>
                                    {((searchOptions !== undefined && isStatusFilter) || isSearchBox) && <div className={cx('le-form-row col-md-6')}>
                                        <div className={cx(`le-form-field m-1`, { 'd-flex-alone justify-content-right': isSearchBox })}>
                                            {searchOptions !== undefined && isStatusFilter ?
                                                <div className={'header-d-flex col-md-6 w-270'}>
                                                    {
                                                        <Select
                                                            isClearable={false}
                                                            name={`${prefix}-filter`}
                                                            onChange={(eve) => {
                                                                this.handleChange(eve)
                                                            }}
                                                            placeholder={"A"}
                                                            options={searchOptions}
                                                            value={selectedSearchOption}
                                                            className="basic-multi-select col-md-12 mR10"
                                                            classNamePrefix="le-select"
                                                        />
                                                    }
                                                </div>
                                                : <div></div>
                                            }
                                            {isSearchBox ?
                                                <div className={'le-form-field-input d-flex-alone col-md-5  w-270'}>
                                                    <input
                                                        onChange={(eve) => {
                                                            this.props.searchChangeNameHandler(eve)
                                                        }}
                                                        autoComplete={"off"}
                                                        name={'automation-search'}
                                                        placeholder={'Search by name'}
                                                        className={'le-form-input header-search'}
                                                    />
                                                    <div className={`le-field-icon-wrap`}>
                                                        <span className={`le-search-info-text pe-none`}></span>
                                                        <span className={`le-fwrap-item`}>
                                                            <FontAwesomeIcon icon={faMagnifyingGlass} />
                                                        </span>
                                                    </div>
                                                </div>
                                                : <div></div>
                                            }
                                        </div>
                                    </div>}


                                    {
                                        (buttonTxt !== "" || (addonButtons !== undefined && addonButtons.length > 0)) &&
                                        <div className={cx(
                                            "flex items-center justify-center px-8 sm:px-10 ml-1",//"hide"
                                            { 'mr-1': prefix === "automations" }
                                            // {'show': buttonTxt !== "" || (addonButtons !== undefined && addonButtons.length > 0)},
                                        )}>
                                            {
                                                (cancelURL !== undefined || this.props.cancelAction !== undefined) && cancelBtn &&
                                                <Button onClick={() => {
                                                    if (this.props.cancelAction) {
                                                        this.props.cancelAction();
                                                    } else {
                                                        this.cancelBtnClick(cancelURL);
                                                    }
                                                }} className={cx("m-1 me-2 btn-icon le-button lePrimaryBtn")} color={buttonOutLine}>
                                                    Cancel
                                                </Button>
                                            }
                                            <Button onClick={(e) => { this.props.buttonAction(e) }} className={cx("m-1 me-2 btn-icon le-button lePrimaryBtn")} color={buttonOutLine}>
                                                <i className={`hide btn-icon-wrapper ${buttonIcon}`}> </i>
                                                <FontAwesomeIcon icon={buttonIcon} className={`mr-1`} />
                                                <span>{buttonTxt}</span>
                                            </Button>
                                            {
                                                this.props.addonButtons !== undefined && this.props.addonButtons.map((button) => {
                                                    let addonBtnText = button.buttonTxt;
                                                    let addonBtnAction = button.buttonAction;
                                                    let addonBtnOutline = button.buttonOutline;
                                                    let addonBtnIcon = button.buttonIcon;
                                                    return (
                                                        <Button onClick={(e) => { addonBtnAction(e) }} className={cx("m-1 me-2 btn-icon le-button lePrimaryBtn")} color={addonBtnOutline}>
                                                            {addonBtnIcon && <FontAwesomeIcon icon={addonBtnIcon} className={'mr-1'} />}
                                                            <span>{addonBtnText}</span>
                                                        </Button>
                                                    )
                                                })
                                            }

                                        </div>
                                    }
                                    {
                                        isModal !== undefined && closeModal !== undefined && isModal &&
                                        <Button onClick={closeModal} className={'m-1 me-2 btn-icon '} color={'light'}>
                                            <FontAwesomeIcon icon={faXmark} />
                                        </Button>
                                    }

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={cx(``, { 'table-contentWrapper': isClassNeeded === undefined })}>
                    {this.props.mainContent}
                </div>
            </Fragment>
        )
    }
}

export default CommonHeaderContent;
